// Referenced By: CompositePredicate, ReportingQuery & SparseReportingQuery

import { AccountId } from './subscriptions/types';

// https://domain-model.tada.amazon.dev/tree?entity=Filter
export interface Filter {
  readonly or?: CompositePredicate;
  readonly and?: CompositePredicate;
  readonly on?: ComparisonPredicate;
}

export interface CompositePredicate {
  readonly filters: Filter[];
}

export interface ComparisonPredicate {
  readonly field: string;
  readonly comparisonOperator: ComparisonOperator;
  readonly not: boolean;
  readonly values: string[];
}

export enum ComparisonOperator {
  EQUALS = 'EQUALS',
  IN = 'IN'
}

export interface ErrorsIndex {
  readonly index: number;
  readonly errors: Error[];
}

export interface Error {
  readonly message: string;
  readonly code: string;
  readonly fieldLocation: string;
}

export interface ReportFilter {
  include: string[];
}

export interface AccountIdFilter {
  include: AccountId[];
}

export interface ReportSort {
  by: string;
  direction: string;
}
